import { Sigma } from "lucide-react";

const cell = (c) => (typeof c === "number" ? c.toLocaleString("tr-TR", { maximumFractionDigits: 2 }) : String(c ?? ""));

// Teklif Excel'inin salt-okunur özeti: sayfa adları (ilk sayfa yeşil) + ilk 10 satır (formül sonuçları; hesaplanmamışsa formül metni). Dosyanın kendisine dokunulmaz.
export default function OfferPreview({ preview }) {
  if (!preview?.sheets?.length) return <div className="text-[10px] text-slate-400" data-testid="offer-preview-empty">önizleme yok{preview?.error ? ` (${preview.error})` : ""}</div>;
  const cols = Math.max(0, ...preview.rows.map((r) => r.length));
  return (
    <div className="space-y-1" data-no-upper data-testid="offer-preview">
      <div className="flex flex-wrap items-center gap-1">
        {preview.sheets.map((s) => <span key={s} className={`px-1.5 py-0.5 rounded text-[9px] font-semibold ${s === preview.first_sheet ? "bg-emerald-100 text-emerald-800" : "bg-slate-100 text-slate-600"}`} data-testid="offer-preview-sheet">{s}</span>)}
        {preview.formula_count > 0 && <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded bg-amber-100 text-amber-900 text-[9px] font-semibold" title="İndirdiğinizde formüller dosyada aynen durur" data-testid="offer-preview-formulas"><Sigma className="w-2.5 h-2.5" /> {preview.formula_count} formül korunur</span>}
      </div>
      {preview.rows.length > 0 && (
        <div className="overflow-auto max-h-36 border border-slate-200 rounded bg-white">
          <table className="text-[9px] leading-tight border-collapse" data-testid="offer-preview-table">
            <tbody>
              {preview.rows.map((r, ri) => (
                <tr key={ri} className={ri === 0 ? "bg-slate-50 font-semibold" : ""}>
                  <td className="border-b border-r border-slate-200 px-1 py-0.5 text-slate-400 text-right bg-slate-50">{ri + 1}</td>
                  {Array.from({ length: cols }, (_, ci) => <td key={ci} className="border-b border-r border-slate-100 px-1 py-0.5 whitespace-nowrap max-w-[110px] truncate" title={cell(r[ci])}>{cell(r[ci])}</td>)}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
